import ComponentePermissao from "@/Components/Base/Permissao/ComponentePermissao";
import TablePaginadaBasic, { ITablePaginadaBasicProps } from "@/Components/Base/Table/TablePaginadaBasic";
import InscricaoDesconto, { EnumTipoValor } from "@/Models/Domain/Viagem/Inscricao/InscricaoDesconto";
import { Button, Space } from "antd";
import { useNavigate } from "react-router-dom";
import InscricaoDescontoDesativarPopconfirm from "./InscricaoDescontoDesativarPopconfirm";
import Utilitario from "@/Utils/Utilitario";
import { extractorNomePessoa } from "@/Models/Pessoa/Pessoa";

export interface IInscricaoDescontoTableBasicProps extends ITablePaginadaBasicProps<InscricaoDesconto> {
    pathBaseLink?:string;
    onSuccess?:(inscricaoDesconto:InscricaoDesconto, evento:'desativar') => void;
}

export default function InscricaoDescontoTableBasic({
    pathBaseLink,
    onSuccess,
    ...rest
}: IInscricaoDescontoTableBasicProps) {
    const navigate = useNavigate();

    pathBaseLink = pathBaseLink === undefined ? '' : pathBaseLink;

    return <TablePaginadaBasic<InscricaoDesconto>
        {...rest}
        rowKey={(m) => m.codigo.toString()}
        columns={[
            {
                key : "codigo",
                title : "#",
                dataIndex : ["codigo"],
                breakpoints : { xs : 6, sm : 12, md : 3, lg : 3, xl : 2, xxl : 2 }
            },
            {
                key : "viagem",
                title : "Viagem",
                dataIndex : ["viagem", "titulo"],
                breakpoints : { xs : 18, sm : 12, md : 8, lg : 6, xl : 6, xxl : 6 }
            },
            {
                key : "nomePessoaAluno",
                title : "Aluno",
                dataIndex : ["codPessoaAluno"],
                render(value, record, __) {
                    return !isNaN(value) && value > 0 ? extractorNomePessoa(record.pessoaAluno!) : record.nomePessoaAluno;
                },
                breakpoints : { xs : 12, sm : 12, md : 8, lg : 6, xl : 7, xxl : 7 }
            },
            {
                key : "valor",
                title : "Valor",
                dataIndex : ["valor"],
                render(value, record, __) {
                    return record.codTipoValor === EnumTipoValor.PercValor ? `${value.toLocaleString()}%` : Utilitario.toStringDinheiro(value);
                },
                breakpoints : { xs : 12, sm : 12, md : 5, lg : 4, xl : 4, xxl : 4 }
            },
            {
                key : "acoes",
                title : "Ações",
                dataIndex : ["codigo"],
                breakpoints : { xs : 24, sm : 24, md : 24, lg : 5, xl : 5, xxl : 5 },
                render(value, record, index) {
                    return <ComponentePermissao tipo="any" permissoes={["DomainViagemInscricaoInscricaoDescontoAlterar", "DomainViagemInscricaoInscricaoDescontoDesativar", "DomainViagemInscricaoInscricaoDescontoListarPorIdentificador"]}>
                        <Space size="small" wrap>
                            <ComponentePermissao permissoes={["DomainViagemInscricaoInscricaoDescontoListarPorIdentificador"]}>
                                <Button
                                    type='dashed'
                                    size='small'
                                    style={{ width: "min-content" }}
                                    onClick={(ev) => navigate(`${pathBaseLink}Visualizar/${value}`)}
                                >
                                    Ver
                                </Button>
                            </ComponentePermissao>
                            <ComponentePermissao permissoes={["DomainViagemInscricaoInscricaoDescontoAlterar", "DomainViagemInscricaoInscricaoDescontoListarPorIdentificador"]}>
                                <Button
                                    type='primary'
                                    size='small'
                                    style={{ width: "min-content" }}
                                    onClick={(ev) => navigate(`${pathBaseLink}Editar/${value}`)}
                                >
                                    Editar
                                </Button>
                            </ComponentePermissao>
                            <ComponentePermissao permissoes={["DomainViagemInscricaoInscricaoDescontoDesativar"]}>
                                <InscricaoDescontoDesativarPopconfirm 
                                    inscricaoDesconto={record}
                                    onSuccess={() => {
                                        onSuccess?.(record, 'desativar');
                                    }}
                                />
                            </ComponentePermissao>
                        </Space>
                    </ComponentePermissao>;
                },
            }
        ]}
    />
}